package com.kitco.metalynxscrapit.shared.presentation.common

fun String.decimalPartMoreThan(maxDecimalPartDigits: Int): Boolean =
    split(".").getOrNull(1)?.length?.compareTo(maxDecimalPartDigits) == 1
